<app-stages [stages]="stages" currentStage="Przedmiot opodatkowania"></app-stages>
<br>
@if (!pending() && !loading()) {
  @if (taxObjects().length) {
    <app-accordion-group>
      @for (forest of taxObjects(); track $index) {
        <app-accordion-item
          [disabled]="showItemForm"
          [name]="(application() | taxObjectTitle) + ($index + 1)">
          <app-tax-object-item-preview [taxObject]="forest">
          </app-tax-object-item-preview>
          <span slot='action'>
            <button
              (click)='onEditTaxObject($event, $index)'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              [disabled]='showItemForm'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              type='button'
              class='btn btn-red-secondary icon-btn'
              title='Usuń z listy'
              [disabled]='showItemForm'
              (click)='onRemove($index, $event)'>
              <i class='fa fa-trash-alt'></i>
            </button>
          </span>
        </app-accordion-item>
      }
    </app-accordion-group>
  } @else {
    <app-alert [alertTitle]="customTitles?.noDataInfo || 'Brak dodanych lasów!'" [closable]="false"></app-alert>
  }
  @if (showItemForm) {
    <app-tax-object-item-form
      [customTitles]="customTitles"
      [edit]='currentIndex() !== undefined'
      [form]='form'
      (onCancel)='showItemForm = false'
      (onSubmit)='onUpdateTaxObjectData($event)'>
    </app-tax-object-item-form>
  } @else {
    <br>
    <div [style]="{ visibility: forceNext ? 'hidden' : 'visible' }" class='form-actions'>
      <button type='button' class='btn btn-primary' (click)='onAdd()'>
        {{ taxObjects().length ? (customTitles?.addBtn2Title || "Dodaj kolejny las") : (customTitles?.addBtnTitle || "Dodaj las") }}
      </button>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button
      [routerLink]="cancelUrl"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="forceNext ? goNext() : submitAndGoNext()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
